
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'message-video',

	props: {
		src: String,

		isWidget: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		videoLink(): string {
			if (this.src) {
				return this.src.replace('watch?v=', 'embed/') + '?autoplay=1';
			}

			return '';
		},
		// Проверяем является ли видео загруженным на платформу
		isLoadedVideo(): boolean {
			return (
				!!this.src?.includes('dev.buddybot.tools') || !!this.src?.includes('borisbot.com')
			);
		}
	}
});
